"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_top_tabs_1 = require("@react-navigation/material-top-tabs");
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const BackHeader_1 = __importDefault(require("../../assets/icons/BackHeader"));
const components_1 = require("../../components");
const header_1 = require("../../components/header");
const constants_1 = require("../../constants");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const helpler_1 = require("../../utils/helpler");
const DisconnectScreen_1 = require("../DisconnectScreen");
const Follow_1 = __importDefault(require("./Follow/Follow"));
const Followers_1 = require("./Followers");
const Tab = (0, material_top_tabs_1.createMaterialTopTabNavigator)();
const FollowScreen = (props) => {
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const initTabIndex = props?.route?.params?.initTabIndex || 0;
    const userHandle = props?.route?.params?.userHandle;
    const navigation = (0, native_1.useNavigation)();
    const [follow, setFollow] = (0, react_1.useState)('');
    const [follower, setFollower] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        const followListener = new react_native_1.NativeEventEmitter().addListener(constants_1.listenerEvents.FOLLOW_COUNTER_UPDATE, (params) => {
            setFollow(params);
        });
        const followerListener = new react_native_1.NativeEventEmitter().addListener(constants_1.listenerEvents.FOLLOWER_COUNTER_UPDATE, (params) => {
            setFollower(params);
        });
        return () => {
            followListener.remove();
            followerListener.remove();
        };
    }, []);
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: { backgroundColor: '#F7F7F7', flex: 1 } },
        react_1.default.createElement(header_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: myProfile?.user_handle == userHandle ? 'マイページ' : `@${userHandle}`, styleContainer: {
                backgroundColor: 'white',
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: '#292A33' }), onLeftPress: navigation.goBack }),
        react_1.default.createElement(Tab.Navigator, { initialRouteName: initTabIndex == 0 ? Routes_1.default.FOLLOW : Routes_1.default.FOLLOWERS, tabBar: (props) => react_1.default.createElement(components_1.CustomTabBar, { ...props }), screenOptions: {
                swipeEnabled: false,
                lazy: true,
            } },
            react_1.default.createElement(Tab.Screen, { name: Routes_1.default.FOLLOW, component: Follow_1.default, initialParams: { userHandle }, options: {
                    tabBarLabel: `${typeof follow === 'string' ? '' : (0, helpler_1.formatNumber)(follow)} フォロー中`,
                } }),
            react_1.default.createElement(Tab.Screen, { name: Routes_1.default.FOLLOWERS, component: Followers_1.Followers, initialParams: { userHandle }, options: {
                    tabBarLabel: `${typeof follower === 'string' ? '' : (0, helpler_1.formatNumber)(follower)} フォロワー`,
                } }))));
};
exports.default = FollowScreen;
